import React from 'react'
import "./layout.css";
import LilyHeader from './lily-header'
import { Outlet } from 'react-router-dom'
import LilyFooter from './lily-footer'
import PTRPortalFooter from './ptr-portal-footer';

const Layout = (props) => {
    return (
        <div className='App'>
            <LilyHeader />
            <div className='body d-flex flex-column justify-content-between'>
                <div className='d-flex justify-content-center'>
                    <Outlet />
                </div>
                <PTRPortalFooter />
            </div>
        </div>
    )
}

export default Layout